/**
 * Les phrases de la fiche d'un viewer (`fiche-viewer.tsx`) et les formats de ses dates. Rien du serveur n'est
 * affiche tel quel : un code d'erreur n'a que sa phrase, ecrite ici. Les dates de l'API sont en ISO 8601 (UTC) ;
 * la fiche les ecrit toutes en toutes lettres, a l'heure de Paris.
 */

export const FICHE_TITRE = "Fiche du viewer";
export const FICHE_FERMER = "Fermer la fiche";
export const FICHE_RETOUR = "Retour au direct";
export const FICHE_CHARGEMENT = "Lecture de la fiche...";
export const FICHE_INTROUVABLE = "Viewer introuvable.";
export const FICHE_ERREUR = "La fiche n'a pas pu être lue. Réessaie dans un instant.";
export const FICHE_DATE_ILLISIBLE = "date illisible";

export const FICHE_PREMIER_PASSAGE = "Premier passage le";
export const FICHE_PAS_FOLLOWER = "pas follower";

export const CHIFFRES_LABELS = {
  streams: "Streams",
  minutes: "Minutes",
  messages: "Messages",
  bits: "Bits",
  follow: "Follow",
  subs: "Subs",
} as const;

export const BADGE_FOLLOWER = "follower";
export const BADGE_ABONNE = "abonné";

export const ANCIEN_TITRE = "Avant La Taverne";
export const ANCIEN_PREMIERE_VENUE = "Première venue";
export const ANCIEN_JAMAIS_VENU = "jamais venu";

export const BOURSE_TITRE = "Sa bourse";
export const BOURSE_VIDE = "Arrive avec les dés.";
export const GAINS_TITRE = "Ses gains";
export const GAINS_VIDE = "Arrive avec les badges.";

export const MESSAGES_TITRE = "Ses messages";
export const MESSAGES_CHERCHER = "Chercher";
export const MESSAGES_CHERCHER_PLACEHOLDER = "un mot";
export const MESSAGES_CHARGEMENT = "Lecture des messages...";
export const MESSAGES_AUCUN = "Aucun message.";
export const MESSAGES_AUCUN_RESULTAT = "Aucun message ne correspond.";
export const MESSAGES_ERREUR = "Les messages n'ont pas pu être lus. Réessaie dans un instant.";
export const MESSAGES_VOIR_PLUS = "Voir plus de messages";
export const MESSAGES_HORS_STREAM = "Hors stream";

const DATE_LONGUE = new Intl.DateTimeFormat("fr-FR", {
  dateStyle: "long",
  timeZone: "Europe/Paris",
});
const HEURE = new Intl.DateTimeFormat("fr-FR", {
  hour: "2-digit",
  minute: "2-digit",
  timeZone: "Europe/Paris",
});
const NOMBRE = new Intl.NumberFormat("fr-FR");

function lire(iso: string): Date | null {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** « 26 mars 2026 », a l'heure de Paris ; une date illisible ne leve pas. */
export function dateLongue(iso: string): string {
  const date = lire(iso);
  return date === null ? FICHE_DATE_ILLISIBLE : DATE_LONGUE.format(date);
}

/** « 14:03 », a l'heure de Paris. */
export function heureCourte(iso: string): string {
  const date = lire(iso);
  return date === null ? FICHE_DATE_ILLISIBLE : HEURE.format(date);
}

/** Un nombre a la francaise : « 1 284 ». */
export function nombre(valeur: number): string {
  return NOMBRE.format(valeur);
}

export function avatarAlt(nom: string): string {
  return `Avatar Twitch de ${nom}`;
}

/** Le titre d'un groupe de messages : le titre du stream, ou sa date quand il n'en a pas. */
export function groupeTitre(titre: string | null, debut: string): string {
  return titre === null || titre.trim() === "" ? `Stream du ${dateLongue(debut)}` : titre;
}

export function groupeDate(debut: string): string {
  return dateLongue(debut);
}

/** L'heure d'un message : la date est celle du groupe qui le porte. */
export function messageQuand(envoyeLe: string): string {
  return heureCourte(envoyeLe);
}
